import React from 'react';
import { ViewControls } from 'shared/components/ViewControls';
import { TransparentButton } from 'shared/components/Buttons';
import { ThreePartSplit } from 'shared/components/ThreePartSplit';
import { PageContent } from 'shared/components/PageContent';
import { HeaderControls } from 'scenes/header';
import { SearchTreeReports } from '../../reportsList/components/SearchTreeReports';
import { BacktestingPortfolioValueGrid } from '../components/BacktestingPortfolioValueGrid';
import { BacktestingExceptionsGrid } from '../components/BacktestingExceptionsGrid';
import { BackTestingChart } from '../components/BacktestingChart';
import './Backtesting.scss';

export const Backtesting: React.FC = () => (
  <PageContent
    searchTree={<SearchTreeReports />}
    headerControls={<HeaderControls />}
    viewControls={
      <ViewControls>
        <TransparentButton
          text="Export"
          iconSrc="Download"
          onClick={() => window.print()}
        />
      </ViewControls>
    }
  >
    <div className="backtesting-page">
      <ThreePartSplit
        topLeft={<BacktestingPortfolioValueGrid />}
        topRight={<BacktestingExceptionsGrid />}
        bottom={<BackTestingChart />}
      />
    </div>
  </PageContent>
);
